import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { TRootState } from "../../../../store";
import { setAllBeneficiaries, setFilterData, setIsLoading, TBeneficiaries } from "./beneficiariesSlice";
import useAxiosClient from "../../../../hooks/useAxiosClient";
import { toast } from "react-toastify";

const useBeneficiaries = () => {

    const dispatch = useDispatch();

    const { handleGetCall } = useAxiosClient();

    const [searchText, setSearchText] = useState('');

    const [isCollapsed, setIsCollapsed] = useState(false);

    const { tableClick, allBeneficiaries, adminId, payoutClick, openBeneficiary, openFilter, statusFilters, refreshGetAll, roleType, addBenefiSteps } = useSelector((state: TRootState) => ({
        tableClick: state.beneficiary.tableClick,
        allBeneficiaries: state.beneficiary.allBeneficiaries,
        adminId: state.auth.adminId,
        payoutClick: state.beneficiary.payoutClick,
        openBeneficiary: state.beneficiary.openBeneficiary,
        openFilter: state.beneficiary.openFilter,
        statusFilters: state.beneficiary.statusFilters,
        refreshGetAll: state.beneficiary.refreshGetAll,
        roleType: state.auth.userInfo.roleType,
        addBenefiSteps: state.beneficiary.addBenefiSteps
    }));

    useEffect(() => {
        getAllBeneficiaries();
    }, [searchText, refreshGetAll])

    const getAllBeneficiaries = () => {
        dispatch(setIsLoading(true));
        handleGetCall<TBeneficiaries[]>(
            `payments/payouts/adminId/${adminId}/tp-bens`
        )
            .then(({ data }) => {
                if (data) {
                    dispatch(setAllBeneficiaries(data));
                    dispatch(setIsLoading(false));
                } else {
                    dispatch(setAllBeneficiaries([]));
                    dispatch(setIsLoading(false));
                }
            })
            .catch((err: any) => {
                toast.error(err.response.data.status.description);
            });
    }

    useEffect(() => {
        const timer = setTimeout(() => {
            filteredData();
        }, 300);

        return () => clearTimeout(timer);
    }, [statusFilters?.status, searchText, allBeneficiaries]);

    const filteredData = () => {
        let filtered = allBeneficiaries;
        const trimmedSearchText = searchText.trim().replace(/[\s.]+/g, "").toLowerCase();
        filtered = filtered?.filter(
            (option) =>
            (option.actHolder &&
                option.actHolder.toString().toLowerCase().replace(/[\s.]+/g, "").includes(trimmedSearchText))
        );

        if (statusFilters?.status?.length > 0) {
            filtered = filtered.filter((option) => {
                const mappedStatus = option.status === 1 ? "ACTIVE" : "INACTIVE";
                return statusFilters.status.includes(mappedStatus);
            });
        };

        dispatch(setFilterData(filtered));
    }

    const isFilterApplied = () => {
        return (
            statusFilters.status.length > 0
        );
    };

    const onRefresh = () => {
        getAllBeneficiaries();
    };

    return {
        searchText,
        setSearchText,
        isCollapsed,
        setIsCollapsed,
        tableClick,
        allBeneficiaries,
        payoutClick,
        openBeneficiary,
        openFilter,
        isFilterApplied,
        roleType,
        onRefresh,
        addBenefiSteps
    }
}
export default useBeneficiaries;